import { v4 as uuidv4 } from "uuid";
import { requireProducts } from "./productsSlice";
import { restoreOrder } from "./shoppingCartSlice";
import buildReorderEntries from "../utils/reorder";

/**
 * "Pedir de novo": carrega as perguntas dos produtos do último pedido,
 * confere tudo contra o cardápio atual e põe na sacola o que ainda vale.
 * Devolve quantos itens entraram e quantos ficaram de fora.
 */
export const reorderItems = (items) => async (dispatch, getState) => {
  const productIds = [...new Set((items || []).map((i) => i.productId))];
  await Promise.all(productIds.map((id) => dispatch(requireProducts(id))));

  const { products } = getState();
  const { entries, skipped } = buildReorderEntries(
    items,
    products.items,
    products.questionsByProduct,
  );

  entries.forEach((entry) =>
    dispatch(restoreOrder({ uuid: uuidv4(), ...entry })),
  );

  return { added: entries.length, skipped };
};
